<template>
  <section class="main-content">
    <section class="main-content__full section">
      <header class="section__header">
        <nav class="breadcrumb">
          <ul class="breadcrumb__list">
            <li class="breadcrumb__level">
              <router-link to="/" class="breadcrumb__link">Categories</router-link>
            </li>

            <li class="breadcrumb__level">
              <a class="breadcrumb__link breadcrumb__link--inactive">All categories</a>
            </li>
          </ul>
        </nav>
      </header>

      <categories-listing class="section__content categories categories--full"></categories-listing>
    </section>
  </section>
</template>

<script>

export default {
  name: 'Categories'
}
</script>



// WEBPACK FOOTER //
// src/components/Categories.vue